var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApertoDeMao(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108.140 75.171",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 18.851 51.724 L 53.687 21.73 L 38.197 0 L 0 26.195 L 18.851 51.724 Z",
    fill: "rgb(252,252,48)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 32.245 12.500)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 21.798 41.861 L 0 17.858 L 17.049 0 L 42.029 18.167 L 21.798 41.861 Z",
    fill: "rgb(135,195,190)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 17.672 15.747)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.955 21.407 L 1.333 7.657 C -0.372 6.049 -0.453 3.371 1.155 1.666 L 1.463 1.333 C 3.071 -0.372 5.75 -0.453 7.455 1.155 L 22.076 14.906 C 23.781 16.513 23.862 19.191 22.255 20.896 L 21.946 21.229 C 20.339 22.926 17.66 23.007 15.955 21.407 Z",
    fill: "rgb(135,195,190)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 53.124 33.749)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.693 22.097 L 1.406 7.713 C -0.389 6.024 -0.478 3.2 1.211 1.406 C 2.899 -0.388 5.725 -0.478 7.519 1.211 L 22.806 15.595 C 24.6 17.283 24.689 20.108 23.001 21.902 C 21.32 23.696 18.495 23.785 16.693 22.097 Z",
    fill: "rgb(135,195,190)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 45.290 38.060)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.603 22.243 L 1.43 7.972 C -0.397 6.251 -0.486 3.37 1.235 1.543 L 1.349 1.43 C 3.07 -0.397 5.944 -0.486 7.779 1.235 L 22.952 15.506 C 24.779 17.226 24.868 20.1 23.147 21.934 L 23.033 22.056 C 21.312 23.874 18.438 23.964 16.603 22.243 Z",
    fill: "rgb(135,195,190)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 39.916 41.924)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 13.746 19.572 L 1.43 7.98 C -0.397 6.26 -0.486 3.386 1.235 1.552 L 1.349 1.43 C 3.07 -0.397 5.944 -0.486 7.779 1.235 L 20.094 12.827 C 21.921 14.548 22.01 17.421 20.289 19.256 L 20.175 19.377 C 18.454 21.204 15.58 21.293 13.746 19.572 Z",
    fill: "rgb(135,195,190)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 35.435 48.458)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 0.673 23.718 L 7.46 29.579 C 8.272 30.277 9.498 30.188 10.196 29.376 L 27.732 9.066 C 28.43 8.254 28.341 7.029 27.529 6.331 L 20.742 0.47 C 19.93 -0.228 18.704 -0.139 18.006 0.673 L 0.47 20.983 C -0.228 21.786 -0.139 23.012 0.673 23.718 Z",
    fill: "rgb(220,160,155)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 11.552 9.943)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 0.867 21.299 L 12.355 31.21 C 13.402 32.111 14.977 31.997 15.878 30.95 L 30.483 14.042 C 31.385 12.994 31.271 11.42 30.224 10.519 L 18.736 0.607 C 17.689 -0.294 16.114 -0.18 15.213 0.867 L 0.607 17.776 C -0.294 18.823 -0.18 20.397 0.867 21.299 Z",
    fill: "rgb(220,160,155)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 27.996 23.625 L 20.616 29.989 C 19.967 30.549 18.984 30.476 18.424 29.827 L 0.377 8.924 C -0.183 8.275 -0.11 7.293 0.539 6.741 L 7.919 0.377 C 8.568 -0.183 9.551 -0.11 10.111 0.539 L 28.158 21.441 C 28.718 22.091 28.645 23.065 27.996 23.625 Z",
    fill: "rgb(220,160,155)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 60.494 10.589)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M 30.596 21.217 L 18.613 31.558 C 17.704 32.337 16.34 32.24 15.553 31.331 L 0.525 13.927 C -0.254 13.018 -0.157 11.654 0.753 10.867 L 12.736 0.525 C 13.645 -0.254 15.009 -0.156 15.796 0.753 L 30.824 18.156 C 31.603 19.057 31.505 20.429 30.596 21.217 Z",
    fill: "rgb(220,160,155)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 69.202 0.683)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.319 10.788 L 10.926 10.207 L 0.607 -0.581 L 0 0 L -0.607 0.581 L 9.711 11.369 L 10.319 10.788 Z",
    fill: "rgb(0,45,75)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 61.748 47.981)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.695 9.165 L 9.304 8.586 L 0.61 -0.578 L 0 0 L -0.61 0.578 L 8.085 9.743 L 8.695 9.165 Z",
    fill: "rgb(0,45,75)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 56.470 53.257)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.695 9.165 L 9.304 8.586 L 0.61 -0.578 L 0 0 L -0.61 0.578 L 8.085 9.743 L 8.695 9.165 Z",
    fill: "rgb(0,45,75)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 51.193 58.533)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 1.314 7.729 L 8.613 1.056 C 10.261 -0.446 12.81 -0.332 14.312 1.308 C 15.814 2.956 15.7 5.505 14.06 7.006 L 6.762 13.679 C 5.114 15.181 2.564 15.067 1.062 13.427 C -0.448 11.779 -0.334 9.231 1.314 7.729 Z",
    fill: "rgb(252,252,48)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 22.171 39.148)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 1.308 7.729 L 8.606 1.056 C 10.255 -0.446 12.804 -0.332 14.306 1.308 C 15.808 2.956 15.694 5.505 14.054 7.006 L 6.755 13.679 C 5.107 15.181 2.558 15.067 1.056 13.427 C -0.446 11.779 -0.332 9.231 1.308 7.729 Z",
    fill: "rgb(252,252,48)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 27.349 45.658)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 1.314 6.43 L 7.192 1.056 C 8.84 -0.446 11.389 -0.332 12.891 1.308 C 14.393 2.948 14.279 5.505 12.639 7.006 L 6.762 12.38 C 5.114 13.881 2.564 13.768 1.062 12.128 C -0.448 10.481 -0.334 7.932 1.314 6.43 Z",
    fill: "rgb(252,252,48)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 33.115 52.112)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 1.193 5.087 L 5.699 0.964 C 7.193 -0.408 9.515 -0.303 10.887 1.199 C 12.259 2.693 12.153 5.014 10.651 6.386 L 6.145 10.51 C 4.652 11.882 2.33 11.776 0.958 10.275 C -0.406 8.781 -0.301 6.459 1.193 5.087 Z",
    fill: "rgb(252,252,48)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 39.284 58.422)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 9.7 L 0.557 10.33 L 11.517 0.629 L 10.96 0 L 10.403 -0.629 L -0.557 9.071 L 0 9.7 Z",
    fill: "rgb(0,45,75)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 26.197 44.969)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 8.702 L 0.553 9.335 L 10.514 0.633 L 9.961 0 L 9.409 -0.633 L -0.553 8.069 L 0 8.702 Z",
    fill: "rgb(0,45,75)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 31.474 52.502)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 8.093 L 0.585 8.696 L 8.923 0.603 L 8.338 0 L 7.752 -0.603 L -0.585 7.49 L 0 8.093 Z",
    fill: "rgb(0,45,75)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 37.969 58.793)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 1.97 6.751 L 10.429 0.833 C 12.516 -0.628 15.39 -0.117 16.851 1.97 C 18.312 4.056 17.801 6.929 15.714 8.391 L 7.255 14.308 C 5.169 15.769 2.295 15.258 0.833 13.172 C -0.628 11.086 -0.117 8.212 1.97 6.751 Z",
    fill: "rgb(252,252,48)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 38.994 25.840)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 23.248 L 0.636 23.798 L 20.713 0.549 L 20.077 0 L 19.441 -0.549 L -0.636 22.699 L 0 23.248 Z",
    fill: "rgb(0,45,75)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 10.756 9.139)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 20.767 23.606 L 21.398 23.051 L 0.631 -0.555 L 0 0 L -0.631 0.555 L 20.136 24.16 L 20.767 23.606 Z",
    fill: "rgb(0,45,75)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 69.971 9.188)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 2.03 4.059 C 3.151 4.059 4.059 3.15 4.059 2.029 C 4.059 0.909 3.151 0 2.03 0 C 0.909 0 0 0.909 0 2.029 C 0 3.15 0.909 4.059 2.03 4.059 Z",
    fill: "rgb(0,45,75)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 17.672 31.170)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 2.03 4.059 C 3.151 4.059 4.059 3.15 4.059 2.029 C 4.059 0.909 3.151 0 2.03 0 C 0.909 0 0 0.909 0 2.029 C 0 3.15 0.909 4.059 2.03 4.059 Z",
    fill: "rgb(0,45,75)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 78.561 31.170)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 8.117 C 0 8.117 8.297 13.784 14.491 11.356 C 20.694 8.929 17.731 4.87 17.731 4.87 L 11.82 0 L 0 8.117 Z",
    fill: "rgb(252,252,48)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 3.795 2.638) matrix(1 0 0 1 49.335 25.488)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApertoDeMao);
export default __webpack_public_path__ + "static/media/aperto-de-mao.b2fd37812359a7be508bf57386933c35.svg";
export { ForwardRef as ReactComponent };